module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payTitulo":"An exclusive  rate tailored to your needs.","payText":"At UniversalPay we adapt all our services to your needs. And the rates, too.","payBtn":"SIGN UP NOW"},"es":{"payTitulo":"Una tarifa única a medida de tus necesidades.","payText":"En UniversalPay adaptamos todos nuestros servicios a tus necesidades. Y las tarifas, también.","payBtn":"CONTRATA AHORA"}}')
  delete Component.options._Ctor
}
